/**
 * Überraschungs Limited Probe countdown ticker.
 *
 * One persistent interval (started once for the whole page) that each second
 * finds every `.jb-mgcd[data-ends]` currently in the DOM and rewrites its
 * `[data-jb-mgcd-time]` cell. Because it re-queries the DOM each tick, it keeps
 * working when the cart drawer re-injects the markup via innerHTML — and because
 * it's a single global interval, re-renders never stack timers.
 *
 * It only reads the DOM and writes text into its own cell; it never touches the
 * cart, so it can't interfere with add-to-cart / checkout.
 *
 * The digits are also server-rendered in Liquid, so the countdown is correct on
 * first paint (and after every re-render) even before this script runs.
 *
 * "Nur heute" over several days: `data-ends` is the end of the current day and
 * the optional `data-promo-end` the end of the promotion. When a day runs out
 * while the promotion continues (a tab left open over midnight), the target
 * rolls forward by whole days, capped at `data-promo-end`. Without
 * `data-promo-end` the countdown simply ends at `data-ends`, as before.
 */
(function () {
  if (window.__jbMgCountdownStarted) return;
  window.__jbMgCountdownStarted = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var timers = document.querySelectorAll('.jb-mgcd[data-ends]');
    for (var i = 0; i < timers.length; i++) {
      var root = timers[i];
      var cell = root.querySelector('[data-jb-mgcd-time]');
      if (!cell) continue;

      var end = new Date(root.getAttribute('data-ends')).getTime();
      if (isNaN(end)) continue;

      var now = Date.now();
      var promoEnd = new Date(root.getAttribute('data-promo-end') || '').getTime();
      if (!isNaN(promoEnd)) {
        while (end <= now && end < promoEnd) end = Math.min(end + 86400000, promoEnd);
      }

      var diff = end - now;
      if (diff <= 0) {
        root.classList.add('is-ended');
        continue;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;

      cell.textContent = (d > 0 ? d + 'T ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      root.classList.remove('is-ended');
    }
  }

  tick();
  setInterval(tick, 1000);
})();
